import React from "react";

import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import File from "@peracto/peracto-editor-ui/dist/File";
import Select from "@peracto/peracto-editor-ui/dist/Select";

const ImageAndTextForm = ({
    onChange,
    state: {
        url = "",
        imageAndTextHeading = "",
        imageAndTextSubHeading = "",
        imageAndTextHeadingColour = "text-brand-black",
        imageAndTextSubHeadingColour = "text-brand-white",
        imageAndTextText = "",
        imageAndTextButtonText = "",
        imageAndTextButtonLink = "",
        imageAndTextButtonColour = "primary",
    },
}) => {
    const buttonColourOptions = [
        { label: "Primary", value: "primary" },
        { label: "Secondary", value: "secondary" },
    ];

    const imageAndTextHeadingColourOptions = [
        { label: "Black", value: "text-brand-black" },
        { label: "White", value: "text-brand-white" },
        { label: "Primary", value: "text-brand-primary" },
        { label: "Secondary", value: "text-brand-secondary" },
        { label: "Tertiary", value: "text-brand-tertiary" },
    ];

    return (
        <>
            <File
                label="Image URL"
                value={url}
                onChange={(value) => onChange({ url: value })}
                isInline={false}
            />

            <TextInput
                label="Heading"
                value={imageAndTextHeading}
                onChange={(e) =>
                    onChange({ imageAndTextHeading: e.target.value })
                }
            />

            <Select
                label="Heading Colour"
                value={imageAndTextHeadingColour}
                onChange={(e) =>
                    onChange({ imageAndTextHeadingColour: e.value })
                }
                options={imageAndTextHeadingColourOptions}
            />

            <TextInput
                label="Sub Heading"
                value={imageAndTextSubHeading}
                onChange={(e) =>
                    onChange({ imageAndTextSubHeading: e.target.value })
                }
            />

            <Select
                label="Sub Heading Colour"
                value={imageAndTextSubHeadingColour}
                onChange={(e) =>
                    onChange({ imageAndTextSubHeadingColour: e.value })
                }
                options={imageAndTextHeadingColourOptions}
            />

            <TextInput
                label="Text"
                value={imageAndTextText}
                onChange={(e) => onChange({ imageAndTextText: e.target.value })}
            />

            <TextInput
                label="Button Text"
                value={imageAndTextButtonText}
                onChange={(e) =>
                    onChange({ imageAndTextButtonText: e.target.value })
                }
            />

            <TextInput
                label="Button Link"
                value={imageAndTextButtonLink}
                onChange={(e) =>
                    onChange({ imageAndTextButtonLink: e.target.value })
                }
            />

            <Select
                label="Button Colour"
                value={imageAndTextButtonColour}
                onChange={(e) =>
                    onChange({ imageAndTextButtonColour: e.value })
                }
                options={buttonColourOptions}
            />
        </>
    );
};

export default ImageAndTextForm;
